<template>
  <BaseNavItem :title="$t('title')" :icon="$vuetify.icons.values.deals" :route="targetRoute" :visible="visible" />
</template>

<script>
import { mapState } from 'vuex'
import { BaseNavItem } from '@argon/app/components'
import { NAMESPACE as ORG_NAMESPACE } from '@argon/iam/organizations/store'
import boardPerimeter from '@argon/evo/boards/perimeters'

export default {
  name: 'IndividualDealsNavItem',
  components: { BaseNavItem },
  perimeters: [boardPerimeter],
  computed: {
    ...mapState(ORG_NAMESPACE, ['activeOrgRefname']),
    targetRoute() {
      let params = this.activeOrgRefname
        ? { orgRef: this.activeOrgRefname, boardRef: 'life-individual' }
        : { ...this.$route.params, boardRef: 'life-individual' }
      return { name: 'tableView', params }
    },
    visible() {
      return this.$board.isAllowed('list')
    }
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Life Individual"
  },
  "fr": {
    "title": "Vie individuel"
  }
}
</i18n>
